<template>
  <div id="offersSlider" class="offers-slider">
    <div v-for="galleryBanner in gallery_banners" :key="galleryBanner.id" class="offers-slider__link">
      <picture>
        <source :srcset="galleryBanner.image.webp" media="(max-width: 767px)" type="image/webp">
        <img :alt="galleryBanner.title" :data-src="galleryBanner.image.source" width="100" height="100" class="img lazyload">
      </picture>
      <!-- Text content container -->
      <div class="offers-slider__content">
        <h2 class="offers-slider__title">{{ galleryBanner.title }}</h2>
        <a :href="galleryBanner.link" :title="galleryBanner.link_title" class="offers-slider__button">
          {{ galleryBanner.link_title }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerGallery",
  props: [
    'gallery_banners'
  ],
}
</script>

<style scoped>
.offers-slider {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: auto;
}

.offers-slider__link {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: left; /* Align text to the left */
}

.offers-slider__content {
  position: absolute;
  left: 10%; /* Move content to the left */
  bottom: 30%;
  color: white;
  z-index: 10;
  text-align: left; /* Align text content to the left */
  width: 50%;
}

.offers-slider__title {
  font-size: 3rem; /* Increase font size to match desired look */
  font-weight: bold;
  margin-bottom: 20px;
}

.offers-slider__button {
  display: inline-block;
  padding: 15px 40px; /* Increase button padding */
  background-color: transparent;
  color: white;
  border: 2px solid white;
  border-radius: 8px; /* Rounded corners */
  font-weight: bold;
  text-decoration: none;
  font-size: 1.2rem;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.offers-slider__button:hover {
  background-color: white;
  color: #000;
}

@media (max-width: 767px) {
  .offers-slider__title {
    font-size: 2rem;
  }

  .offers-slider__button {
    padding: 10px 20px;
    font-size: 1rem;
  }
}
</style>